import { render } from "./InspectionForm.vue?vue&type=template&id=31d9c736"
import script from "./InspectionForm.vue?vue&type=script&lang=js"
export * from "./InspectionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__